import React from "react";
import Breadcrumb from "../components/Breadcrumb";
import AddHighLightLayer from "../components/AddHighlightLayer";
 
 
const AddHighlightPage = () => {
  return (
    <>
   
 
        {/* Breadcrumb */}
        <div className="d-flex justify-content-between"><h5>Add Highlight  </h5><Breadcrumb title="Add Highlight" /></div>
 
        {/* CalendarMainLayer */}
        <AddHighLightLayer />
 
 
    </>
  );
};
 
export default AddHighlightPage;
 
 